import {
    createColumnDate,
    createColumnInput,
    createColumnSelect,
    createColumnTreeSelect
} from "../../../../components/table/c-table.logic";
import i18n from "../../../../i18n";
import { putField } from "../../../../utils/form";
import { callUserObjective } from "../../haz/request/request.section";
import { callRequestDepartment } from "../../storage-location/request/requestor/requestor.section";
import { callDocumentStatus } from "../../storage-location/storage-location/storage-location.section";
import { callHazObject, callHazType } from "../../haz/request/haz-info/haz-info.section";
import { dateDiffStr } from "../../../../utils/date";

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("views.report.docType"),
            dataIndexValue: () => i18n.global.t("views.report.haz"),
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.approveCode"),
            dataIndex: "approveCode2",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.approveCodeOld"),
            dataIndex: "approveCodeOld",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.approveCode"),
            dataIndex: "approveCode",
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refHazObject"),
            dataIndex: "refHazObject.nameTh",
            inputProp: () => ({ list: callHazObject, optLabel: "nameTh" }),
            search: { name: "refHazObject.id" }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.tradeNameTh").replace(" (TH)", ""),
            dataIndex: "tradeNameTh",
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refOperation"),
            dataIndex: "refOperation.value",
            inputProp: () => ({ list: callUserObjective, optLabel: "value" }),
            search: { visible: () => false, name: "refOperation.id" }
        }),
        createColumnInput({
            title: () => i18n.global.t("model.haz.refUserCompany"),
            dataIndex: "refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refUserCompany?.refPersonType?.key === "1" ? record.refUserCompany?.companyNameTh : record.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnTreeSelect({
            title: () => i18n.global.t("model.request.refDepartment"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({
                list: () => callRequestDepartment({ refRequestDocKey: "04" }),
                renderLabel: ({ item }) => (
                    <div>
                        {item.fullCode} : {item.nameTh}
                    </div>
                ),
                filterWhere: ({ value }) => [
                    { name: "fullCode", operator: "like", value },
                    { logic: "OR", name: "nameTh", operator: "like", value }
                ],
                treeDefaultExpandAll: true
            }),
            search: { name: "refDepartment.id" },
            width: 200
        }),
        createColumnDate({ title: () => i18n.global.t("views.report.docEffectiveDate"), dataIndex: "effectiveDate", align: "center" }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refType"),
            dataIndex: "refType.value",
            inputProp: () => ({ list: callHazType, optLabel: "value" }),
            search: { name: "refType.id" }
        }),
        createColumnDate({ title: () => i18n.global.t("model.haz.expireDate"), dataIndex: "expireDate", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("views.report.docTimeLive"),
            // dataIndexValue2: () => "6 ปี",
            dataIndexValue: ({ record }) => dateDiffStr({ record }), sorter: false,
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "center",
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("views.report.toUse"),
            dataIndex: "toUse",
            dataIndexValue: ({ record }) => {
                return record.toUse || record.products.map(d => d.refProduct?.value).join(", ");
            },
            customRender: ({ record, column }) => column.dataIndexValue({ record }),
            align: "left",
            sorter: false,
            search: { visible: () => false }
        }),
        createColumnInput({
            title: () => i18n.global.t("views.report.manufacturer"),
            dataIndex: "manufacturer",
            align: "center",
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.haz.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({ list: callDocumentStatus, optLabel: "value" }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ data }) => {
    return putField({
        data,
        fields: []
    });
};
